// Keep the persisted key and cross-tab lock stable for existing browser profiles.
const BROWSER_INSTALLATION_ID_KEY = 'driver360-notifications-installation-id'

// Auth may establish notification ownership, but must work without browser storage.
export const getOptionalBrowserInstallationId = async (): Promise<
  string | undefined
> => {
  try {
    return await getBrowserInstallationId()
  } catch {
    return undefined
  }
}

export const getExistingBrowserInstallationId = (): string | null => {
  try {
    return localStorage.getItem(BROWSER_INSTALLATION_ID_KEY)
  } catch {
    return null
  }
}

export const getBrowserInstallationId = async (): Promise<string> => {
  const existingId = getExistingBrowserInstallationId()
  if (existingId) return existingId

  if (!navigator.locks) {
    throw new Error(
      'Browser locks are required to create a notification installation',
    )
  }

  return navigator.locks.request(BROWSER_INSTALLATION_ID_KEY, () => {
    const savedId = localStorage.getItem(BROWSER_INSTALLATION_ID_KEY)
    if (savedId) return savedId

    const browserInstallationId = crypto.randomUUID()
    localStorage.setItem(BROWSER_INSTALLATION_ID_KEY, browserInstallationId)
    return browserInstallationId
  })
}
